
  import { defineComponent, ref, watch } from 'vue';
  
  export default defineComponent({
    props: {
      keyValue: {
      type: String,
      required: false
    },
      label: {
        type: String,
        required: true
      },
      required:{
      type: Boolean,
      required: false,
    },
      value: {
        type: Number,
        required: true
      }
    },
    setup(props, { emit }) {
      const inputValue = ref(props.value);
  
      watch(() => props.value, (newValue) => {
        inputValue.value = newValue;
      });

      const updateValue = () => {
        emit('update', { key: props.keyValue || props.label, value: inputValue.value });
      };
  
      return {
        inputValue,
        updateValue
      };
    }
  });
  